import { colors } from '@material-ui/core';

export default {
  root: {
    color: colors.blueGrey[600],
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)',
    },
  },
};
